import { DatePipe } from '@angular/common';
import { PipeTransform, Pipe, inject, LOCALE_ID } from '@angular/core';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeformat implements PipeTransform {
  private readonly datePipe = inject(DatePipe);
  private readonly locale = inject(LOCALE_ID);

  transform(value: string | Date | null): string | null {
    if (!value)
      return null;

    const now = new Date();
    // eslint-disable-next-line prefer-const
    const d = new Date(value);
    const twentyFourHoursLater = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    if (d < twentyFourHoursLater) {
      return this.datePipe.transform(value, 'MM/dd/yyyy', undefined, this.locale) as string;
    } else {
      return this.datePipe.transform(value, 'h:mm a', undefined, this.locale) as string;
    }
  }
}